<script>
import _ from 'underscore'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    strict: true,
    state: {
        user: null,
        loggedIn: false
    },
    mutations: {
        login (state, user) {
            state.user = user
            state.loggedIn = true

            localStorage.setItem('user', JSON.stringify(user))
        },
        update (state, user) {
            state.user = _.extend(state.user, user)

            localStorage.setItem('user', JSON.stringify(state.user))
        },
        logout (state) {
            state.user = { }
            state.loggedIn = false

            localStorage.removeItem('user')
        }
    }
})

const savedUser = localStorage.getItem('user')
if (savedUser !== null) {
    store.commit('login', JSON.parse(savedUser))
}

export default store
</script>


// WEBPACK FOOTER //
// store.vue?3dab85e0